import {PLAYER_STATE} from 'utils/constants';

export function shouldShowThumbnail(playerState) {
  return [PLAYER_STATE.READY, PLAYER_STATE.COMPLETED].includes(playerState);
}

